var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7509 15.5482C16.8299 15.6272 16.8925 15.721 16.9353 15.8241C16.978 15.9273 17 16.0379 17 16.1496C17 16.2613 16.978 16.3718 16.9353 16.475C16.8925 16.5782 16.8299 16.6719 16.7509 16.7509C16.6719 16.8299 16.5782 16.8925 16.475 16.9353C16.3718 16.978 16.2613 17 16.1496 17C16.0379 17 15.9273 16.978 15.8241 16.9353C15.721 16.8925 15.6272 16.8299 15.5482 16.7509L8.5 9.70162L1.45177 16.7509C1.29228 16.9104 1.07597 17 0.850425 17C0.624878 17 0.408569 16.9104 0.249084 16.7509C0.0895981 16.5914 4.44607e-09 16.3751 0 16.1496C-4.44607e-09 15.924 0.0895981 15.7077 0.249084 15.5482L7.29838 8.5L0.249084 1.45177C0.0895981 1.29228 0 1.07597 0 0.850425C0 0.624878 0.0895981 0.408569 0.249084 0.249084C0.408569 0.0895981 0.624878 0 0.850425 0C1.07597 0 1.29228 0.0895981 1.45177 0.249084L8.5 7.29838L15.5482 0.249084C15.7077 0.0895981 15.924 -4.44607e-09 16.1496 0C16.3751 4.44607e-09 16.5914 0.0895981 16.7509 0.249084C16.9104 0.408569 17 0.624878 17 0.850425C17 1.07597 16.9104 1.29228 16.7509 1.45177L9.70162 8.5L16.7509 15.5482Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.88e5a18bd67647cb956b115e9804ddeb.svg";
export { ForwardRef as ReactComponent };